import { handleActions } from 'redux-actions';

import { m, indexOfId } from '../utils';
import { getData, postData, putData } from '../utils/request';

const initialState = {
  tier: 'Pro',
  startTime: 11,
  startDate: m().startOf('isoWeek'),
  endDate: m().endOf('isoWeek'),
  duration: 8,
  shifts: [],
  filteredParkinglots: [{ id: 1 }],
  selectedShifts: [],
  hasPreferences: true,
  availableShifts: [],
};

const ADD_TO_SELECTED_SHIFTS = 'ADD_TO_SELECTED_SHIFTS';
const REMOVE_FROM_SELECTED_SHIFTS = 'REMOVE_FROM_SELECTED_SHIFTS';
const ADD_TO_FILTERED_PARKINGLOTS = 'ADD_TO_FILTERED_PARKINGLOTS';
const REMOVE_FROM_FILTERED_PARKINGLOTS = 'REMOVE_FROM_FILTERED_PARKINGLOTS';
const INITIAL_FILTERED_PARKINGLOTS = 'INITIAL_FILTERED_PARKINGLOTS';
const CHANGE_FILTERED_TIER = 'CHANGE_FILTERED_TIER';
const CLEAR_SELECTED_SHIFTS = 'CLEAR_SELECTED_SHIFTS';
const CHANGE_START_TIME = 'CHANGE_START_TIME';
const CHANGE_DURATION = 'CHANGE_DURATION';
const INITIAL_SHIFTS = 'INITIAL_SHIFTS';
const LOAD_AVAILABLE_SHIFTS = 'LOAD_AVAILABLE_SHIFTS';
const CHANGE_DATES = 'CHANGE_DATES';
const BOOKING_CARS_RETRIVED = 'BOOKING_CARS_RETRIVED';
const SET_PREFERENCES = 'SET_PREFERENCES';
const NO_PREFERENCES = 'NO_PREFERENCES';

/* ******************** ACTIONS ******************** */

/* ******************** SHIFT LIST ACTIONS ******************** */

const addToSelectedShifts = shift => ({
  type: [ADD_TO_SELECTED_SHIFTS],
  shift,
});

export const removeFromSelectedShifts = shift => ({
  type: [REMOVE_FROM_SELECTED_SHIFTS],
  shift,
});

export const clearSelectedShifts = () => ({
  type: [CLEAR_SELECTED_SHIFTS],
});

export const toggleShiftList = (shift, selected) => dispatch =>
  // Check if clicked shift timeslot is already selected
  // Remove if selected, add otherwise
  selected ? dispatch(removeFromSelectedShifts(shift)) : dispatch(addToSelectedShifts(shift));

/* ******************** END SHIFT LIST ACTIONS ******************** */

/* ******************** FILTER ACTIONS ******************** */

/* ******************** SHIFT FILTER ACTIONS ******************** */

export const handleChangeDate = (startDate, endDate) => ({
  type: [CHANGE_DATES],
  startDate,
  endDate,
});

export const handleStartTimeFilter = startTime => ({
  type: [CHANGE_START_TIME],
  startTime,
});

export const handleDurationFilter = duration => ({
  type: [CHANGE_DURATION],
  duration,
});

export const initialShifts = shifts => ({
  type: [INITIAL_SHIFTS],
  shifts,
});

export const loadAvailableShifts = availableShifts => ({
  type: [LOAD_AVAILABLE_SHIFTS],
  availableShifts,
});

const bookingCarsRetrieved = cars => ({
  type: [BOOKING_CARS_RETRIVED],
  cars,
});

export const searchAvailableShifts = params => dispatch =>
  postData('bookings/search_available', params).then(response => {
    dispatch(loadAvailableShifts(response));
    dispatch(bookingCarsRetrieved(response));
  });

/* ******************** END SHIFT FILTER ACTIONS ******************** */

/* ******************** PARKINGLOT FILTER ACTIONS ******************** */

export const handleParkinglotFilter = (parkinglot, isInputChecked) => dispatch => {
  if (isInputChecked) {
    dispatch(addToFilteredParkinglots(parkinglot));
  } else {
    dispatch(removeFromFilteredParkinglots(parkinglot));
  }
};

const addToFilteredParkinglots = parkinglot => ({
  type: [ADD_TO_FILTERED_PARKINGLOTS],
  parkinglot,
});

const removeFromFilteredParkinglots = parkinglot => ({
  type: [REMOVE_FROM_FILTERED_PARKINGLOTS],
  parkinglot,
});

export const initialFilteredParkinglots = parkinglots => ({
  type: [INITIAL_FILTERED_PARKINGLOTS],
  parkinglots,
});

/* ******************** END PARKINGLOT FILTER ACTIONS ******************** */

/* ******************** TIER FILTER ACTIONS ******************** */

const changeFilteredTier = tier => ({
  type: [CHANGE_FILTERED_TIER],
  tier,
});

/* ******************** TIER FILTER ACTIONS ******************** */

/* ******************** END TIER FILTER ACTIONS ******************** */

/* ******************** END FILTER ACTIONS ******************** */

/* ******************** START PREFERENCES ACTIONS ******************** */

const setPreferences = preferences => ({
  type: [SET_PREFERENCES],
  preferences,
});

export const noPreferences = () => ({
  type: [NO_PREFERENCES],
});

export const checkPreferences = () => dispatch => {
  getData('booking_preferences').then(response => {
    if (response !== null) {
      dispatch(setPreferences(response));
    } else {
      dispatch(noPreferences());
    }
  });
};

export const newPreferences = body => dispatch => {
  const { duration, location, startTime, tier } = body;
  const data = {
    start_time: startTime,
    location,
    duration,
    tier,
  };
  postData('booking_preferences', data).then(response => {
    dispatch(setPreferences(response));
  });
};

export const changePreferences = body => dispatch => {
  putData('booking_preferences', body).then(response => {
    dispatch(setPreferences(response));
  });
};

/* ******************** END PREFERENCES ACTIONS ******************** */

export const handleTierFilter = tier => dispatch => {
  dispatch(changeFilteredTier(tier));
};
/* ******************** END TIER FILTER ACTIONS ******************** */

/* ******************** END FILTER ACTIONS ******************** */

/* ******************** REDUCERS ******************** */

export default handleActions(
  {
    [ADD_TO_SELECTED_SHIFTS]: (state, { shift }) => ({
      ...state,
      selectedShifts: [...state.selectedShifts, shift],
    }),

    [REMOVE_FROM_SELECTED_SHIFTS]: (state, { shift }) => {
      const idx = state.selectedShifts.map(s => s.uid).indexOf(shift.uid);
      return {
        ...state,
        selectedShifts: [...state.selectedShifts.slice(0, idx), ...state.selectedShifts.slice(idx + 1)],
      };
    },

    [CLEAR_SELECTED_SHIFTS]: state => ({
      ...state,
      selectedShifts: [],
    }),

    /* ******************** SHIFT FILTER REDUCERS ******************** */

    [CHANGE_START_TIME]: (state, { startTime }) => ({
      ...state,
      startTime,
    }),

    [CHANGE_DATES]: (state, { startDate, endDate }) => ({
      ...state,
      startDate,
      endDate,
    }),

    [CHANGE_DURATION]: (state, { duration }) => ({
      ...state,
      duration,
    }),

    [INITIAL_SHIFTS]: (state, { shifts }) => ({
      ...state,
      shifts,
    }),

    /* ******************** END SHIFT FILTER REDUCERS ******************** */

    /* ******************** PARKINGLOT FILTER ACTIONS ******************** */

    [ADD_TO_FILTERED_PARKINGLOTS]: (state, { parkinglot }) => ({
      ...state,
      filteredParkinglots: [...state.filteredParkinglots, parkinglot],
    }),

    [REMOVE_FROM_FILTERED_PARKINGLOTS]: (state, { parkinglot }) => {
      const id = indexOfId(state.filteredParkinglots, parkinglot.id);
      return {
        ...state,
        filteredParkinglots: [...state.filteredParkinglots.slice(0, id), ...state.filteredParkinglots.slice(id + 1)],
      };
    },

    [INITIAL_FILTERED_PARKINGLOTS]: (state, { parkinglots }) => ({
      ...state,
      filteredParkinglots: parkinglots,
    }),

    /* ******************** END PARKINGLOT FILTER ACTIONS ******************** */

    /* ******************** TIER FILTER ACTIONS ****** ************* */

    [CHANGE_FILTERED_TIER]: (state, { tier }) => ({
      ...state,
      tier,
    }),

    /* ******************** END TIER FILTER ACTIONS ******************** */

    [BOOKING_CARS_RETRIVED]: (state, { cars }) => ({
      ...state,
      cars,
    }),

    [SET_PREFERENCES]: (state, { preferences }) => ({
      ...state,
      tier: preferences.tier,
      startTime: preferences.start_time,
      duration: preferences.duration,
      hasPreferences: true,
      filteredParkinglots: [preferences.parkinglot],
    }),

    [NO_PREFERENCES]: state => ({
      ...state,
      hasPreferences: false,
    }),

    [LOAD_AVAILABLE_SHIFTS]: (state, { availableShifts }) => ({
      ...state,
      availableShifts,
    }),
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/redux/book.js